export var TABTYPE;
(function (TABTYPE) {
  TABTYPE["SALE"] = "sale-tab";
  TABTYPE["RENT"] = "rent-tab";
  TABTYPE["AUCTION"] = "auction-tab";
  TABTYPE["AGENCY"] = "agency-tab";
  TABTYPE["VALUATE"] = "valuation-tab";
  TABTYPE["SELLING"] = "sell-tab";
  TABTYPE["TREND"] = "trend-tab";
})(TABTYPE || (TABTYPE = {}));